import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=e1e9b98c"
import script from "./CaseMenu.vue?vue&type=script&lang=js"
export * from "./CaseMenu.vue?vue&type=script&lang=js"
import style0 from "./CaseMenu.vue?vue&type=style&index=0&id=e1e9b98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports